import { useEffect, useState } from 'react';

import styles from './PriceGraph.scss';

const ANIMATION_DELAY = 500;

const CURVE_PATH = 'M6 13C22.4 16.2 23.3333 31.5 28.5 36C37.3787 43.733 46.2331 22.2361 56.5 28C66 33.3333 70 66.5 100 63';

type PriceGraphProps = {
  className?: string;
};

export const PriceGraph = ({ className }: PriceGraphProps) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), ANIMATION_DELAY);
    return () => clearTimeout(timer);
  }, []);

  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      viewBox="0 0 107 77"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Full dotted grey path (always visible) */}
      <path
        d={CURVE_PATH}
        fill="none"
        stroke="#A0A0A0"
        strokeDasharray="2 2"
        strokeWidth="2"
      />

      {/* Animated blue solid path that reveals via gradient */}
      <path
        className={animate ? styles.pathAnimate : styles.pathHidden}
        d={CURVE_PATH}
        fill="none"
        stroke="url(#priceGraphGradient)"
        strokeWidth="2"
      />

      {/* Blue circle at peak */}
      <circle
        className={animate ? styles.circleAnimate : styles.circleHidden}
        cx="54"
        cy="27"
        fill="#0022A2"
        r="3.5"
      />

      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="priceGraphGradient"
          x1="8"
          x2="100"
          y1="13"
          y2="65"
        >
          <stop stopColor="#0022A2" />
          <stop offset="0.469746" stopColor="#0022A2" />
          <stop offset="0.479318" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
